// src/pages/LoginRedirect.jsx
import React, { useContext, useEffect, useRef } from "react";
import { AuthContext } from "../AuthProvider";
import Spinner from "../components/Spinner";
import { useTranslation } from "react-i18next";

const Screen = ({ children }) => (
  <div className="min-h-screen flex flex-col items-center justify-center
                  bg-gray-100 text-gray-800
                  dark:bg-gray-900 dark:text-gray-100
                  transition-colors">
    {children}
  </div>
);

const LoginRedirect = () => {
  const { kcReady, authenticated, login } = useContext(AuthContext);
  const triedRef = useRef(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!kcReady) return;

    if (authenticated) {
      // al ingelogd -> naar home
      window.location.replace("/");
      return;
    }

    if (!triedRef.current) {
      triedRef.current = true;
      login({ redirectUri: window.location.origin + "/" });
    }
  }, [kcReady, authenticated, login]);

  if (!kcReady) {
    return (
      <Screen>
        <Spinner />
        <p className="mt-3">{t("home.loading_authentication", "Preparing authentication…")}</p>
      </Screen>
    );
  }

  return (
    <Screen>
      <Spinner />
      <p className="mt-3">{t("home.redirecting_login", "Redirecting to login…")}</p>
    </Screen>
  );
};

export default LoginRedirect;